import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Tooltip } from "@/components/atoms/Tooltip";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  children: ReactNode;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, children, className, tooltipSide = "bottom", ...rest },
  ref,
) {
  return (
    <Tooltip content={label} side={tooltipSide}>
      <button
        ref={ref}
        aria-label={label}
        className={cn(
          "inline-flex items-center justify-center h-9 w-9 rounded-md",
          "text-bridge-muted hover:text-bridge-fg hover:bg-white/5 transition-colors focus-ring",
          className,
        )}
        {...rest}
      >
        {children}
      </button>
    </Tooltip>
  );
});